import React from "react";
import { useAuth } from "../contexts/AuthContext";
import "./Login.css";

export const Login: React.FC = () => {
  const auth = useAuth();

  const handleLogin = () => {
    auth.signinRedirect();
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>ERP Uploader</h1>
          <p>Please sign in to upload files</p>
        </div>

        {auth.error && (
          <div className="error-message">{auth.error.message}</div>
        )}

        <div className="login-content">
          <button
            className="login-btn"
            onClick={handleLogin}
            disabled={auth.isLoading}
          >
            {auth.isLoading ? (
              <>
                <span className="spinner"></span>
                Signing in...
              </>
            ) : (
              <>
                <span className="login-icon">🔐</span>
                Sign in with Authentik
              </>
            )}
          </button>

          <div className="login-info">
            <p>
              You will be redirected to Authentik to complete the sign-in
              process.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
